/* -- Generated File: Do Not Edit ------------------------------------------ */
export const boxShadows = {
  boxShadowGray0: '0 1px 2px 0 rgba(0,0,0,0), 0 0 2px 0 rgba(0,0,0,0.10)',
  boxShadowGray1: '0 2px 4px 0 rgba(0,0,0,0.10), 0 0 2px 0 rgba(0,0,0,0.10)',
  boxShadowGray2: '0 4px 8px 0 rgba(0,0,0,0.10), 0 0 2px 0 rgba(0,0,0,0.10)',
  boxShadowGray3: '0 8px 16px 0 rgba(0,0,0,0.10), 0 0 2px 0 rgba(0,0,0,0.10)',
  boxShadowBlack0: '0 1px 2px 0 rgba(0,0,0,0), 0 0 2px 0 rgba(0,0,0,0.10)',
  boxShadowBlack1: '0 2px 4px 0 rgba(0,0,0,0.50), 0 0 2px 0 rgba(0,0,0,0.60)',
  boxShadowBlack2: '0 4px 8px 0 rgba(0,0,0,0.50), 0 0 2px 0 rgba(0,0,0,0.60)',
  boxShadowBlack3: '0 8px 16px 0 rgba(0,0,0,0.50), 0 0 2px 0 rgba(0,0,0,0.60)',
};

export default boxShadows;
/* -- Generated File: Do Not Edit ------------------------------------------ */
